export default __webpack_public_path__ + "static/living-planet-72d9581e0f9afec1d6d1c1502f01af33.jpg";